import { useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

import successModal from "../../assets/images/app/allaya/success-modal-icon.svg";

import { Card, Container, CardBody, Row, Col } from "reactstrap";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { resetPassFormValidationSchema, initialValues } from "./FormValidations";
import { PasswordInput } from "../../components/Input";
import { CustomButton } from "../../components/CustomButton";
import { CustomModal, InformationModal } from "../../components/CustomModal";
import { LABLES, NAMES, PLACEHOLDERS } from "./AccountFieldsNames";
import { MODULE_KEYS, getKey } from "../../api/api.keys";
import { ChangePasswordAccount } from "../../api/api.service";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
import { Helmet } from "react-helmet";
import { PageTitles } from "../../constants";
import { ERROR, showToast } from "../../utils/toastUtils";

const ChangePassword = () => {
    let { id: userID } = useSelector((state) => state.userAuth.user);
    let { PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD } = LABLES;

    const [showResetSuccessModal, setShowResetSuccessModal] = useState(false);

    const formik = useFormik({
        initialValues: initialValues.changePassword,
        validationSchema: resetPassFormValidationSchema,
        onSubmit: (values, { resetForm }) => {
            handleFormSubmit(values, resetForm);
        }
    });

    let { useMutate } = useRequestProcessor();
    let { mutate, isLoading } = useMutate(
        "",
        getKey([MODULE_KEYS.ACCOUNT_CHANGE_PASSWORD]),
        (data) => ChangePasswordAccount(data)
    );

    const handleFormSubmit = (values, resetForm) => {
        const { oldPassword, newPassword } = values;
        let bodyData = {
            oldPassword: oldPassword,
            newPassword: newPassword
        };
        mutate(bodyData, {
            onSuccess: (res) => {
                setShowResetSuccessModal(true);
                resetForm();
            }
        });
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit} className="p-4">
                <Row>
                    <Col sm="12" md="6" lg="6">
                        <PasswordInput
                            disabled={isLoading}
                            placeholder={PLACEHOLDERS[PASSWORD]}
                            label={PASSWORD}
                            name={NAMES[PASSWORD]}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values[NAMES[PASSWORD]]}
                            size="lg"
                            className="text-input"
                        />
                        <FormikErrorText formikInstance={formik} fieldName={NAMES[PASSWORD]} />
                    </Col>
                </Row>
                <Row className="my-md-3 my-lg-3">
                    <Col sm="12" md="6" lg="6">
                        <PasswordInput
                            disabled={isLoading}
                            placeholder={PLACEHOLDERS[NEW_PASSWORD]}
                            label={NEW_PASSWORD}
                            name={NAMES[NEW_PASSWORD]}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values[NAMES[NEW_PASSWORD]]}
                            size="lg"
                            className="text-input"
                        />
                        <FormikErrorText formikInstance={formik} fieldName={NAMES[NEW_PASSWORD]} />
                    </Col>
                    <Col sm="12" md="6" lg="6">
                        <PasswordInput
                            disabled={isLoading}
                            placeholder={PLACEHOLDERS[CONFIRM_PASSWORD]}
                            label={CONFIRM_PASSWORD}
                            name={NAMES[CONFIRM_PASSWORD]}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values[NAMES[CONFIRM_PASSWORD]]}
                            size="lg"
                            className="text-input"
                        />
                        <FormikErrorText
                            formikInstance={formik}
                            fieldName={NAMES[CONFIRM_PASSWORD]}
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-end mt-2">
                    <Col sm="12" md="3" lg="3" className="d-flex justify-content-end">
                        <CustomButton
                            loading={isLoading}
                            type={"submit"}
                            title="Update Password"
                            color="primary"
                            className="custom-btn-md  mt-2 grad-primary"
                        />
                    </Col>
                </Row>
            </form>

            <InformationModal
                size="md"
                isOpen={showResetSuccessModal}
                Title={"Your password has been updated successfully"}
                confirmButtonText="Done"
                ImageSrc={successModal}
                onConfirmClick={() => setShowResetSuccessModal(false)}
            />
        </>
    );
};

export default ChangePassword;
